export const apiConfig = {
  baseUrl: process.env.REACT_APP_SERVER || 'https://v2-dev.trellisplatform.com/api/account/v1',
};

export const wssConfig = {
  baseUrl: process.env.REACT_APP_SERVER_WS || 'wss://v2-dev.trellisplatform.com/api/account/v1/merchant',
};
